import React from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { NAMES_TO_COLOR_CODES } from 'client/site-modules/infographics/constants/most-popular-colors';

import './top-colors.scss';

export function TopColors({ content = DEFAULT_CONTENT, isMobile = false }) {
  const colorsEntries = content.children().map(entry => ({ ...entry, ...entry.getAllMetadata() }));
  return (
    <div className="top-colors-wrapper">
      <div className="top-colors d-flex w-100 mb-3">
        {colorsEntries.map(entry => {
          const roundedPercent = Math.round(entry.colorPercent.replace('%', ''));
          return (
            <div
              key={entry.id}
              className="color-section d-flex flex-column align-items-md-center justify-content-start"
              style={{
                flexGrow: roundedPercent,
              }}
            >
              <div
                style={{
                  height: '23px',
                  backgroundColor: NAMES_TO_COLOR_CODES[entry.color],
                  border: entry.color === 'white' ? '1px solid #E6E6E6' : 'none',
                }}
                className="color-block w-100"
              />
              <p className="size-16 mb-0 mt-0_5">
                <span className="fw-bold">{roundedPercent}%</span> {isMobile && <br />} {entry.colorName}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

TopColors.propTypes = {
  content: CmsEntities.Content,
  isMobile: PropTypes.bool,
};
